'use client'

import { LogoHeading } from './logo-heading'
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarFooter,
  SidebarItem,
  SidebarLabel,
  SidebarSection,
} from './sidebar'
import { SidebarLayout } from './sidebar-layout'
import {
  StopCircleIcon
} from '@heroicons/react/16/solid'
import {
  HomeIcon,
  DocumentPlusIcon,
  ArrowRightStartOnRectangleIcon,
  MagnifyingGlassIcon,
  Cog8ToothIcon
} from '@heroicons/react/20/solid'
import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import config from '../config.js'
import { useSession } from './session-provider';
import { Loader } from './loader'

const menusList = [
  { label: "Dashboard", name: "dashboard", href: "/dashboard", icon: <HomeIcon /> },
  { label: "Add/manage accounts", name: "manage-accounts", href: "/manage-accounts", icon: <DocumentPlusIcon /> },
  { label: "My Settings", name: "my-settings", href: "/my-settings", icon: <Cog8ToothIcon /> },
];
const commonMenus = ["/dashboard", "/add-new-company-gmc", "/my-settings", "/manage-accounts"];
export function SidebarLayoutNew({ selected_menu, showsidebar = true, content_color = "",children }) {
	const navigate = useNavigate();
	const { session, setSession } = useSession();
  const location = useLocation();
  const pathname = location.pathname;
  const userCompanies = session.user_companies;
  var currentCompany = session.sumo_account_id;
	const [loading, setLoading] = useState(false);
  const [searchClient, setSearchClient] = useState("");
  var filteredCompanies = userCompanies;
  const isCommonMenu = commonMenus.some(menu_single => pathname.startsWith(menu_single));
  if(userCompanies !== undefined && userCompanies !== null) {
    filteredCompanies = Object.fromEntries(
      Object.entries(userCompanies).filter(
        ([, com]) =>
          com.client_name.toLowerCase().includes(searchClient.toLowerCase())
      )
    );
  }
  const Logout = async() => {
    try {
      setLoading(true);
      await fetch(`${config.apiPath}logout.php`);
      setLoading(false);
      navigate('/');
    }
    catch (error) {
      console.error("Logout failed:", error);
			setLoading(false);
			navigate('/');
    }
  }

	const SwapCompany = async(sumo_account_id) => {
		try {
		  setLoading(true);
		  const response = await fetch(`${config.apiPath}swap-company.php?sumo_account_id=${sumo_account_id}`, { credentials: 'include' });
				const swap_res = await response.json();
		  if(swap_res.status === "success") {
				setSession(swap_res.data);   
			    navigate("/title-test?reload=" + Date.now());
			    setLoading(false);
		  }  else {
			  Logout();
		  }
		}
		catch (error) {
			console.error("Session check failed:", error);
			setLoading(false);
			Logout();
		}
	}
	const GotoPage = (pageName) => {
		navigate(`${pageName}`);
	};
  return (
    <SidebarLayout
    showsidebar = {showsidebar}
    content_color = {content_color}
      navbar=""
      sidebar={
        <Sidebar>
          <SidebarHeader>
            <LogoHeading>FeedSumo</LogoHeading>
          </SidebarHeader>
          <SidebarBody className="[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden ">
            <SidebarSection>
              <div className="flex flex-1 items-center justify-center">
                <div className="grid w-full grid-cols-1 sm:max-w-2xs max-h-[32px]">
                  <input name="search" placeholder="Search" className="col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-3 pl-10 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-indigo-500 max-h-[32px]" value={searchClient} onChange={e => setSearchClient(e.target.value)}
                  />
                  <MagnifyingGlassIcon aria-hidden="true" className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400" />
                </div>
              </div>
            {menusList.map((menu) => (
                <SidebarItem onClick={() => GotoPage(menu.href)} current={pathname.startsWith(menu.href)} /* className={selected_menu === menu.name ? "bg-zinc-300 border-l border-l-3 border-l-zinc-600 rounded-md" : ""} */>
               {/* {selected_menu === menu.name &&
                  (<span className="absolute inset-y-2 -left-4 w-0.5 rounded-full bg-zinc-950 dark:bg-white"></span>)
                } */}
                {menu.icon}
                <SidebarLabel>{menu.label}</SidebarLabel>
              </SidebarItem>
            ))}
            </SidebarSection>
            <SidebarSection className='!mt-1 overflow-y-auto [&::-webkit-scrollbar]:w-1 [&::-webkit-scrollbar-track]:bg-zinc-100 [&::-webkit-scrollbar-thumb]:bg-zinc-400 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb:hover]:bg-zinc-500'>
              {
                filteredCompanies && typeof filteredCompanies === "object" ? (
                  Object.entries(filteredCompanies).map(([id, res], index) => {
                    return(
                      <>
                          <SidebarItem title={res.client_name} onClick={() => SwapCompany(res.sumo_account_id)} className={`cursor-pointer ${currentCompany === res.sumo_account_id && isCommonMenu === false ? 'bg-zinc-300 rounded-md dark:bg-zinc-600' : ''}`}>
                          <StopCircleIcon className='!size-3'/>
                        <SidebarLabel>{res.client_name}</SidebarLabel>
                      </SidebarItem>
                      </>
                    )
                  })
                ) : (
                  // Fallback if filteredCompanies is invalid
                  (() => {
                    console.error("filteredCompanies is invalid, reloading...");
                    window.location.reload();
                    return null;
                  })()
                )
              }
            </SidebarSection>
          </SidebarBody>
          <SidebarFooter>
            <SidebarSection>
              <SidebarItem onClick={() => Logout()} className="cursor-pointer">
                    <ArrowRightStartOnRectangleIcon className='size-2'/>
                  <SidebarLabel>Log out</SidebarLabel>
                </SidebarItem>
            </SidebarSection>
          </SidebarFooter>
        </Sidebar>
      }
    >
      {children}
      {loading && (
        <Loader />
      )}
    </SidebarLayout>
  )
}